/**
 * 外部轨迹「位置」展示拼接工具
 *
 * 与官网轨迹页（official-website 各语种 track 页面的 formatLocation）保持同一口径：
 * 承运商原始位置文本之外，还要带上城市、州省码、邮编与国家码，只渲染 location 会丢掉后四段信息。
 */

/** 轨迹事件中参与位置拼接的字段；后端字段均可能为空，故全部按可空处理 */
export interface TrackingLocationFields {
    location?: string | null;
    cityUppercase?: string | null;
    iso3166Sc?: string | null;
    postalCode?: string | null;
    iso3166Cc?: string | null;
}

const safeTrim = (value: string | null | undefined): string => (value ? value.trim() : '');

/**
 * 将轨迹事件的位置相关字段拼接为一行展示文本。
 *
 * 顺序为 `location, cityUppercase, iso3166Sc, postalCode, [iso3166Cc]`，空字段自动跳过以免出现连续逗号；
 * 国家码用方括号包裹（如 `[US]`），与官网展示格式一致。
 * 全部字段为空时返回空串，由调用方决定是否渲染该行（不在此处兜底文案，避免工具层耦合 i18n）。
 */
export const formatTrackingLocation = (event: TrackingLocationFields | null | undefined): string => {
    if (!event) return '';

    const parts = [event.location, event.cityUppercase, event.iso3166Sc, event.postalCode]
        .map(safeTrim)
        .filter((part) => part !== '');

    const countryCode = safeTrim(event.iso3166Cc);
    if (countryCode) parts.push(`[${countryCode}]`);

    return parts.join(', ');
};
